import { render, staticRenderFns } from "./InquiryOverview.vue?vue&type=template&id=3227ea09&scoped=true&"
import script from "./InquiryOverview.vue?vue&type=script&lang=js&"
export * from "./InquiryOverview.vue?vue&type=script&lang=js&"
import style0 from "./InquiryOverview.vue?vue&type=style&index=0&id=3227ea09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227ea09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VPagination,VTextField})
